import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header, Footer } from "./components/Layout";
import Home from "./pages/Home";
import HoeHetWerkt from "./pages/HoeHetWerkt";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import VoorBegunstigde from "./pages/VoorBegunstigde";
import Verder from "./pages/Verder";
import LootjesAanmaken from "./pages/LootjesAanmaken";
import LootjesDeelnemen from "./pages/LootjesDeelnemen";
import LootjesBeheer from "./pages/LootjesBeheer";
import JouwLootje from "./pages/JouwLootje";
import css from "./styles";

export default function App() {
  return (
    <>
      <style>{css}</style>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/"               element={<Home />} />
          <Route path="/hoe-het-werkt"  element={<HoeHetWerkt />} />
          <Route path="/contact"        element={<Contact />} />
          <Route path="/privacy"        element={<Privacy />} />
          <Route path="/voor/:token"                    element={<VoorBegunstigde />} />
          <Route path="/verder/:token"                  element={<Verder />} />
          <Route path="/lootjes"                        element={<LootjesAanmaken />} />
          <Route path="/lootjes/doe-mee/:groepToken"    element={<LootjesDeelnemen />} />
          <Route path="/lootjes/beheer/:groepToken"     element={<LootjesBeheer />} />
          <Route path="/lootjes/jouw-lootje/:lootjeToken" element={<JouwLootje />} />
          <Route path="*"               element={<NotFound />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
}

function NotFound() {
  return (
    <main className="main">
      <div className="page-hero fi">
        <div style={{ fontSize: 60, marginBottom: 16 }}>🔍</div>
        <h1>Pagina <em>niet gevonden</em></h1>
        <p>De pagina die je zoekt bestaat niet (meer).</p>
        <a href="/" className="hero-cta" style={{ marginTop: 24 }}>← Terug naar home</a>
      </div>
    </main>
  );
}
